import { render, staticRenderFns } from "./RiskScore.vue?vue&type=template&id=10a73362&"
import script from "./RiskScore.vue?vue&type=script&lang=js&"
export * from "./RiskScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports